export const getMinProposalsDate = (daysWebTender, currentDateTime) => {
  daysWebTender = daysWebTender || 0
  currentDateTime = currentDateTime ? new Date(currentDateTime) : new Date()

  // Добавление секунд к текущей дате
  //const result = daysWebTender ? new Date(currentDateTime.setSeconds(currentDateTime.getSeconds() + daysWebTender)) : currentDateTime
  const result = daysWebTender ? new Date(currentDateTime.getTime() + daysWebTender * 1000) : currentDateTime

  const hour = result.getHours()
  if (hour >= 18) {
    result.setDate(result.getDate() + 1)
  }

  if (result.getDay() === 6) {
    result.setDate(result.getDate() + 2)
    result.setHours(8, 0, 0, 0)
  } else if (result.getDay() === 0) {
    result.setDate(result.getDate() + 1)
    result.setHours(8, 0, 0, 0)
  }

  if (hour < 8 || hour >= 18) { result.setHours(8, 0, 0, 0) }

  return result
}

export const getDefaultProposalsDate = (daysWebTender, currentDateTime) => {
  const minHourEnd = 15 // время завершения всегда не позже 15, если нужно будет, вынесем это в настройку
  currentDateTime = currentDateTime || new Date()
  daysWebTender = daysWebTender || 0

  const countDayOnProp = daysWebTender ? Math.floor(daysWebTender / 86400) : 0

  let minEndTimeTender
  if (countDayOnProp < 3) {
    minEndTimeTender = new Date(currentDateTime.setDate(currentDateTime.getDate() + 3))
  } else {
    minEndTimeTender = new Date(currentDateTime.setSeconds(currentDateTime.getSeconds() + daysWebTender))
  }

  //Проверка времени и установка времени на 08:00, если текущее время больше 18:00:
  const hour = minEndTimeTender.getHours()
  if (hour >= minHourEnd) { minEndTimeTender.setDate(minEndTimeTender.getDate() + 1) }
  minEndTimeTender.setHours(minHourEnd, 0, 0, 0)

  //Проверка, является ли результат субботой или воскресеньем, и сдвиг на следующий понедельник при необходимости:
  if (minEndTimeTender.getDay() === 6) {
    minEndTimeTender.setDate(minEndTimeTender.getDate() + 2)
  } else if (minEndTimeTender.getDay() === 0) {
    minEndTimeTender.setDate(minEndTimeTender.getDate() + 1)
  }
  //Поиск даты в массиве available_days и сдвиг до следующего рабочего дня ("WORK_DAY"):
  /*let available_days = this.$store.getters.getHolidays // доступные дни для работы
  //await tender_api.getHolidays(minEndTimeTender, minEndTimeTender.setMonth(minEndTimeTender.getMonth() + 2))
  //  .then(response => {
  //    let available_days = response // доступные дни для работы
  let found = false
  const minEndTimeTenderISO = minEndTimeTender.toISOString()
  while (!found) {
    const matchingDay = available_days.find(day => day.date === minEndTimeTenderISO)
    if (matchingDay && matchingDay.dayType === 'WORK_DAY') {
      found = true
    } else {
      minEndTimeTender.setDate(minEndTimeTender.getDate() + 1) // Сдвигаем на один день вперед
    }
  }*/

  return minEndTimeTender
}
